(function ($) {
	$(".about_purchase__drop-header").click(function () {
		$(this).toggleClass("about_purchase__drop-header--active");
		$(this).next(".about_purchase__drop-content").slideToggle();
	})
})(jQuery);